"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.PlayIcon = exports.OverlayElement = exports.Inner = exports.Image = exports.DescriptionCaption = exports.Description = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("../../constants");
var _models = require("../../models");
var _constants2 = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  position,
  isSquare
}) => ({
  display: 'grid',
  boxSizing: 'border-box',
  alignSelf: 'start',
  width: _constants2.maxItemWidth,
  overflow: 'hidden',
  justifySelf: 'start',
  '&.olapic-media-sizes': {
    ...(isSquare && {
      height: _constants2.maxItemWidth
    }),
    [theme.breakpoints.up('lg')]: {
      width: `calc((100vw / ${_constants2.baseNumberOfElements}) - ${_constants2.largeGap}px)`,
      minWidth: _constants2.largeMinWidth,
      maxWidth: _constants2.largeMaxWidth,
      ...(isSquare && {
        height: `calc((100vw / ${_constants2.baseNumberOfElements}) - ${_constants2.largeGap}px)`,
        minHeight: _constants2.largeMinWidth,
        maxHeight: _constants2.largeMaxWidth
      })
    }
  },
  ...(position === _models.MediaItemPosition.slider3 && {
    gridRow: '1 / 2',
    scrollSnapAlign: 'start',
    [theme.breakpoints.up('lg')]: {
      gridRow: '1 / 3',
      alignSelf: 'center',
      scrollSnapAlign: 'start'
    }
  }),
  ...(position === _constants2.positionInSlider.first && {
    gridRow: '1 / 2',
    scrollSnapAlign: 'start',
    [theme.breakpoints.up('lg')]: {
      gridRow: '1 / 3',
      alignSelf: 'center',
      ...(isSquare ? {
        marginBottom: theme.spacing(10)
      } : {
        paddingBottom: theme.spacing(10)
      }),
      scrollSnapAlign: 'start',
      '& .olapic-media-description': {
        gridRow: '1 / 2'
      }
    }
  }),
  ...(position === _constants2.positionInSlider.second && {
    gridRow: '1 / 2',
    scrollSnapAlign: 'start',
    [theme.breakpoints.up('lg')]: {
      gridRow: '1 / 2',
      scrollSnapAlign: 'unset',
      '& .olapic-media-description': {
        display: 'none'
      }
    }
  }),
  ...(position === _constants2.positionInSlider.third && {
    gridRow: '1 / 2',
    scrollSnapAlign: 'start',
    [theme.breakpoints.up('lg')]: {
      gridRow: '2 / 3',
      scrollSnapAlign: 'unset',
      '& .olapic-media-description': {
        display: 'none'
      }
    }
  }),
  ...(position === _constants2.positionInSlider.forth && {
    gridRow: '1 / 2',
    scrollSnapAlign: 'start',
    [theme.breakpoints.up('lg')]: {
      gridRow: '1 / 3',
      ...(isSquare ? {
        marginTop: theme.spacing(8)
      } : {
        paddingTop: theme.spacing(8)
      }),
      scrollSnapAlign: 'unset'
    }
  }),
  ...(position === _constants2.positionInSlider.fifth && {
    gridRow: '1 / 2',
    scrollSnapAlign: 'start',
    [theme.breakpoints.up('lg')]: {
      gridRow: '1 / 3',
      alignSelf: 'end',
      scrollSnapAlign: 'unset'
    }
  }),
  ...(position === _models.MediaItemPosition.gallery && {
    alignSelf: 'center',
    justifySelf: 'center',
    width: _constants.galleryBoxSize,
    minWidth: _constants.galleryMinItemWidth,
    maxWidth: _constants.galleryMaxItemWidth,
    height: _constants.galleryBoxSize,
    minHeight: _constants.galleryMinItemWidth,
    maxHeight: _constants.galleryMaxItemWidth,
    [theme.breakpoints.up('sm')]: {
      width: _constants.gallerySMBoxSize,
      height: _constants.gallerySMBoxSize
    },
    '&.olapic-media-sizes': {
      [theme.breakpoints.up('md')]: {
        width: _constants.galleryMDBoxSize,
        minWidth: _constants.galleryMDMinItemWidth,
        maxWidth: _constants.galleryMDMaxItemWidth,
        height: _constants.galleryMDBoxSize,
        minHeight: _constants.galleryMDMinItemWidth,
        maxHeight: _constants.galleryMDMaxItemWidth
      },
      [theme.breakpoints.up('lg')]: {
        width: _constants.galleryMDBoxSize,
        minWidth: _constants.galleryMDMinItemWidth,
        maxWidth: _constants.galleryMDMaxItemWidth,
        height: _constants.galleryMDBoxSize,
        minHeight: _constants.galleryMDMinItemWidth,
        maxHeight: _constants.galleryMDMaxItemWidth
      }
    }
  })
}));
const Inner = exports.Inner = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  position
}) => ({
  display: 'grid',
  position: 'relative',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '1fr',
  width: '100%',
  maxWidth: _constants2.maxItemWidth,
  height: '100%',
  maxHeight: _constants2.maxItemWidth,
  overflow: 'hidden',
  cursor: 'pointer',
  borderRadius: theme.shape.borderRadius,
  '&::before': {
    content: '""',
    display: 'block',
    zIndex: 2,
    gridArea: '1 / 1 / 2 / 2',
    width: '100%',
    paddingTop: '100%'
  },
  '&:hover::before': {
    background: (0, _mui.alpha)(theme.palette.common.black, 0.3)
  },
  '&:hover': {
    '& .olapic-media-overlay': {
      opacity: 1
    }
  },
  [theme.breakpoints.up('lg')]: {
    width: `calc((100vw / ${_constants2.baseNumberOfElements}) - ${_constants2.largeGap}px)`,
    minWidth: _constants2.largeMinWidth,
    maxWidth: _constants2.largeMaxWidth,
    height: `calc((100vw / ${_constants2.baseNumberOfElements}) - ${_constants2.largeGap}px)`,
    minHeight: _constants2.largeMinWidth,
    maxHeight: _constants2.largeMaxWidth
  },
  ...(position === _models.MediaItemPosition.gallery && {
    [theme.breakpoints.up('lg')]: {
      width: _constants.galleryMDBoxSize,
      minWidth: _constants.galleryMDMinItemWidth,
      maxWidth: _constants.galleryMDMaxItemWidth,
      height: _constants.galleryMDBoxSize,
      minHeight: _constants.galleryMDMinItemWidth,
      maxHeight: _constants.galleryMDMaxItemWidth
    }
  })
}));
const Image = exports.Image = (0, _mui.styled)('img')(({
  theme
}) => ({
  display: 'block',
  zIndex: 1,
  gridArea: '1 / 1 / 2 / 2',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: '50% 50%',
  borderRadius: theme.shape.borderRadius
}));
const PlayIcon = exports.PlayIcon = (0, _mui.styled)(_presentationComponents.PlayIcon)({
  position: 'absolute',
  zIndex: 1,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
});
const OverlayElement = exports.OverlayElement = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'grid',
  zIndex: 3,
  boxSizing: 'border-box',
  gridArea: '1 / 1 / 2 / 2',
  alignSelf: 'center',
  width: 'calc(100% - 30px)',
  overflow: 'hidden',
  opacity: 0,
  color: theme.palette.common.white,
  fontWeight: 'normal',
  textAlign: 'center',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  justifySelf: 'center'
}));
const Description = exports.Description = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'block',
  margin: theme.spacing(3, 0)
}));
const DescriptionCaption = exports.DescriptionCaption = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  width: '100%',
  maxWidth: _constants2.largeMaxWidth,
  overflow: 'hidden'
});
